/**
 * @file コンポーネント：フル動画ページ機器広告ポップアップ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Popup } from "~/src/components/projects/Popup";
import { SliderAd } from "~/src/components/projects/Video/SliderAd";

// スタイル読み込み
import {
    StyledPopup,
    StyledPopupContainer,
    StyledPopupContents,
    StyledPopupImage,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledPopupContainer>
            <Popup
                content={[
                    <StyledPopup key="content">
                        <StyledPopupContents ref={props.refContents}>
                            <SliderAd
                                arrows={true}
                                list={props.list.map((image, i) => (
                                    <StyledPopupImage
                                        alt={image.fileName}
                                        key={"image-" + i}
                                        src={image.filePath}
                                    />
                                ))}
                                sliderCover={false}
                                zoom={true}
                            />
                        </StyledPopupContents>
                    </StyledPopup>,
                ]}
                isOpen={props.isOpen}
                setIsOpen={props.setIsOpen}
            />
        </StyledPopupContainer>
    );
};
